import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { STORAGE_API } from '@dges/modules/storage/domain';
import { FirebaseStorageService } from './firebase-storage.service';

export function provideStorageFirebaseApi(): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: STORAGE_API, useExisting: FirebaseStorageService },
  ]);
}
